<script>
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  page: {
    title: "User-Booking",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      formatIST,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: [],
      },
      searchData: debounce(() => {
        this.getMyBookings();
        this.init = false;
      }, 500),
      chargerList: [],
      fields: [
        {
          key: "id",
          sortable: true,
          label: "Booking ID",
        },
        {
          key: "station",
          sortable: true,
          label: "Charging Stations",
        },
        {
          key: "start_time",
          sortable: true,
          label: "Start Time",
        },
        {
          key: "end_time",
          sortable: true,
          label: "End Time",
        },
        {
          key: "minutes",
          sortable: true,
          label: "Total Minutes",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "Unit Price",
        },
        {
          key: "payment_status",
          sortable: true,
          label: "Payment Status",
        },
        {
          key: "info",
          sortable: true,
          label: "Info",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {},
  computed: {
    ...mapGetters("booking", [
      "getAllMyBooking",
      "loading",
      "getAllBookingInfo",
      "getAllMyBookingCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getMyBookings();
  },
  methods: {
    ...mapActions("booking", ["getMyBooking", "getBooking"]),
    getMyBookings(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
        user_id: this.convertDecodeId(this.$route.params.id),
      };
      this.getMyBooking(filters);
    },
    getBookingInfo(booking_id) {
      var data = {
        id: booking_id,
      };
      this.getBooking(data).then(() => {
        this.$bvModal.show("bv-modal-booking-info");
      });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getMyBookings();
    },
    convertDecodeId(id) {
      return (this.user_id = atob(id));
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">Bookings ({{ getAllMyBookingCount }})</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select class="custom-select" v-model="perPages" @change="searchData()">
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :items="getAllMyBooking"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :fields="fields"
                  :busy="loading"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(station)="items">
                    {{ items.item.station ? items.item.station : "" }}
                  </template>
                  <template v-slot:cell(start_time)="items">
                    {{ formatIST(items.item.start_time) }}
                  </template>
                  <template v-slot:cell(end_time)="items">
                    {{ formatIST(items.item.end_time) }}
                  </template>
                  <template v-slot:cell(minutes)="items">
                    {{ items.item.minutes ? items.item.minutes : "-" }}
                  </template>
                  <template v-slot:cell(unit_price)="items">
                    {{ items.item.unit_price ? items.item.unit_price : "-" }}
                  </template>
                  <template v-slot:cell(payment_status)="items">
                    {{ items.item.payment_status ? items.item.payment_status : "-" }}
                  </template>
                  <template v-slot:cell(info)="items">
                    <b-button
                      @click="getBookingInfo(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-info-circle"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllMyBooking.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Booking Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getMyBookings"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <b-modal
      v-if="getAllBookingInfo"
      id="bv-modal-booking-info"
      size="lg"
      hide-footer
      @hidden="resetForm"
    >
      <template #modal-title
        >#{{ getAllBookingInfo.id }} Booking Info
        <span v-if="getAllBookingInfo.booking_type" class="badge badge-pill badge-secondary">{{
          getAllBookingInfo.booking_type.charAt(0).toUpperCase() +
          getAllBookingInfo.booking_type.slice(1)
        }}</span></template
      >
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Booking User Name :
                {{
                  getAllBookingInfo.users ? getAllBookingInfo.users.full_name : "User Deleted"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Email :
                {{
                  getAllBookingInfo.users && getAllBookingInfo.users.email
                    ? getAllBookingInfo.users.email
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Mobile Number :
                {{
                  getAllBookingInfo.users && getAllBookingInfo.users.mobile_number
                    ? getAllBookingInfo.users.mobile_number
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Charging Station :
                {{
                  getAllBookingInfo.chargers ? getAllBookingInfo.chargers.name : "Charger Deleted"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Charging Station Address :
                {{
                  getAllBookingInfo.chargers ? getAllBookingInfo.chargers.address : "User Deleted"
                }}</label
              >
            </div>
          </div>
          <template v-if="getAllBookingInfo.chargers && getAllBookingInfo.chargers.users">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Charger Owner Name : {{ getAllBookingInfo.chargers.users.full_name }}</label>
              </div>
            </div>
          </template>
          <template
            v-if="getAllBookingInfo && getAllBookingInfo.start_time && getAllBookingInfo.end_time"
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Booking Start - Booking End Time :
                  {{ formatIST(getAllBookingInfo.start_time) }} -
                  {{ formatIST(getAllBookingInfo.end_time) }}</label
                >
              </div>
            </div>
          </template>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Pre Auth Transaction Id :
                {{
                  getAllBookingInfo.pre_auth_transaction_id
                    ? getAllBookingInfo.pre_auth_transaction_id
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Pre Auth Charge :
                {{
                  getAllBookingInfo.pre_auth_charge ? getAllBookingInfo.pre_auth_charge : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Final Transaction Id :
                {{
                  getAllBookingInfo?.final_transaction_id ||
                  getAllBookingInfo?.charging_history?.transaction_id ||
                  "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Final Charge :
                {{
                  getAllBookingInfo?.final_charge ||
                  getAllBookingInfo?.charging_history?.total_amount ||
                  "-"
                }}</label
              >
            </div>
          </div>
          <template
            v-if="
              getAllBookingInfo.charging_history &&
              getAllBookingInfo.charging_history.charging_start_time
            "
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Charging Start - Charging End Time :
                  {{ formatIST(getAllBookingInfo.charging_history.charging_start_time) }} -
                  {{ formatIST(getAllBookingInfo.charging_history.charging_end_time) }}</label
                >
              </div>
            </div>
          </template>
          <template v-if="getAllBookingInfo.charging_history">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Charging Unit :
                  {{
                    getAllBookingInfo.charging_history.charging_unit ||
                    (Number(getAllBookingInfo.charging_history.charged_value) / 1000).toFixed(2)
                  }}</label
                >
              </div>
            </div>
          </template>
          <template v-if="getAllBookingInfo.is_cancel == 1">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label>Cancel Time : {{ getAllBookingInfo.cancelled_time }}</label>
              </div>
            </div>
          </template>
          <template v-if="getAllBookingInfo.is_cancel == 1">
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Cancelled By :
                  {{
                    getAllBookingInfo.cancellation_reason == 1 && getAllBookingInfo.is_cancel == 1
                      ? "Cancelled by system"
                      : getAllBookingInfo.cancellation_reason == 2
                      ? "Booking lapsed"
                      : "Cancelled by customer"
                  }}</label
                >
              </div>
            </div>
          </template>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-booking-info');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
        </div>
      </form>
    </b-modal>
  </div>
</template>
